import { render, staticRenderFns } from "./OrganizationSurveyAdd.vue?vue&type=template&id=962667ac&scoped=true&"
import script from "./OrganizationSurveyAdd.vue?vue&type=script&lang=js&"
export * from "./OrganizationSurveyAdd.vue?vue&type=script&lang=js&"
import style0 from "./OrganizationSurveyAdd.vue?vue&type=style&index=0&id=962667ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "962667ac",
  null
  
)

export default component.exports